/*SYSTEM IMPORTS*/
import React from 'react'
import c from 'classnames'

import './style'
import './media'


const ActionWrapp = props => (
    <div className={c("action-wrapp", {"action-wrapp_center": props.center }, props.className)}>
        {props.children}
    </div>
)

export default ActionWrapp
